module.exports = "<span><span *ngIf=\"field\"><strong>{{field}}: </strong></span>\n  <span *ngFor=\"let object of value; let i = index\" [attr.data-index]=\"i\">\n    <a [routerLink]=\"['/admin', className, object._id]\">{{object[displayKey]}}</a><span *ngIf=\"i !== value.length - 1\">, </span>\n  </span>\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/admin/shared/display-array-rel/display-array-rel.component.html
// module id = 290
// module chunks = 0 1